import { getDictionary } from '@synisys/dictionary';
export function getDayNames(locale = 'en', format = 'short') {
    const formatter = new Intl.DateTimeFormat(locale, {
        weekday: format,
        timeZone: 'UTC',
    });
    const days = [1, 2, 3, 4, 5, 6, 7].map(day => new Date(Date.UTC(2016, 1, day)));
    return days.map(date => formatter.format(date));
}
export function getMonthNames(locale = 'en', format = 'short') {
    const formatter = new Intl.DateTimeFormat(locale, {
        month: format,
        timeZone: 'UTC',
    });
    const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(month => new Date(Date.UTC(2017, month, 1)));
    return months.map(date => formatter.format(date));
}
export function getQuarters() {
    return [1, 2, 3, 4].map(quarterNumber => `${getDictionary().translate('sds.quarter')}${quarterNumber}`);
}
export function displayDate(date, locale = 'en') {
    const formatter = new Intl.DateTimeFormat(locale, {
        month: 'short',
        year: 'numeric',
        day: 'numeric',
        timeZone: 'UTC',
    });
    const [year, month, day] = date;
    return formatter.format(new Date(Date.UTC(year, month - 1, day)));
}
export function displayMonth(month, locale = 'en', format = 'short') {
    const formatter = new Intl.DateTimeFormat(locale, {
        month: format,
        timeZone: 'UTC',
    });
    return formatter.format(new Date(Date.UTC(2017, month - 1, 1)));
}
